module.exports = __webpack_public_path__ + "img/typeother.63769c02.png";